import React, { Suspense, lazy, useEffect, useState } from 'react'
import { Button, Table } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { useSelector } from 'react-redux'
import { useImmer } from 'use-immer'
import EditIcon from '../../../components/AllSvgIcon/EditIcon'
import HKBadge from '../../../components/Badges'
import Loader from '../../../components/Loader'
import SearchBox from '../../../components/Searchbox'
import CustomToast from '../../../components/Toast/CustomToast'
import { customStyles } from '../../../components/customStyles'
import {
  calculatePageRange,
  encodedSearchText,
  showToast
} from '../../../lib/AllGlobalFunction'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import { pageRangeDisplayed } from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { _userProfileImg_ } from '../../../lib/ImagePath'
import { _exception } from '../../../lib/exceptionMessage'
import useDebounce from '../../../lib/useDebounce'

const AdminForm = lazy(() => import('./AdminForm'))

const AdminList = () => {
  let initVal = {
    firstName: '',
    lastName: '',
    emailID: '',
    mobileNo: '',
    userTypeId: null,
    status: null,
    password: '',
    confirmPassword: '',
    filename: '',
    cpass: '',
    receiveNotifications: [],
    isPasswordVisible: false,
    isConfirmPasswordVisible: false,
    userName: ''
  }
  const [modalShow, setModalShow] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  const [initialValues, setInitialValues] = useState(initVal)
  const [dropDownData, setDropDownData] = useState()
  const debounceSearchText = useDebounce(searchText, 500)
  const { pageAccess } = useSelector((state) => state.user)
  const [filterDetails, setFilterDetails] = useImmer({
    pageSize: 50,
    pageIndex: 1,
    searchText: ''
  })
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })

  const handlePageClick = (event) => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setFilterDetails((draft) => {
      draft.pageIndex = event.selected + 1
    })
  }

  const fetchData = async () => {
    try {
      setLoading(true)

      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'Account/Admin/Search',
        queryString: `?searchText=${encodedSearchText(
          filterDetails?.searchText
        )}&pageIndex=${filterDetails?.pageIndex}&pageSize=${
          filterDetails?.pageSize
        }`
      })
      setLoading(false)
      if (response?.status === 200) {
        setData(response)
      }
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const fetchDropDownData = async () => {
    const response = await axiosProvider({
      method: 'GET',
      endpoint: 'GetAllRoleTypes',
      queryString: `?pageIndex=0&pageSize=0`
    })

    if (response?.status === 200) {
      setDropDownData(response?.data?.data)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filterDetails])

  useEffect(() => {
    if (debounceSearchText) {
      setFilterDetails((draft) => {
        draft.searchText = debounceSearchText
        draft.pageIndex = 1
      })
    } else {
      setFilterDetails((draft) => {
        draft.searchText = ''
        draft.pageIndex = 1
      })
    }
  }, [debounceSearchText])

  return (
    <>
      <div className='d-flex align-items-center mb-3 gap-3 flex-row-reverse'>
        {checkPageAccess(
          pageAccess,
          allPages?.manageAdmin,
          allCrudNames?.write
        ) && (
          <Button
            variant='warning'
            className='d-flex align-items-center gap-2 fw-semibold btn btn-warning ms-auto'
            onClick={() => {
              setInitialValues(initVal)
              !dropDownData?.length && fetchDropDownData()
              setModalShow(!modalShow)
            }}
          >
            <i className='m-icon m-icon--plusblack'></i>
            Create
          </Button>
        )}

        <div className='page-range'>
          {calculatePageRange({
            ...filterDetails,
            recordCount: data?.data?.pagination?.recordCount ?? 0
          })}
        </div>

        <div className='d-flex align-items-center'>
          <label className='me-1'>Show</label>
          <select
            styles={customStyles}
            menuPortalTarget={document.body}
            name='dataget'
            id='parpageentries'
            className='form-select me-1'
            value={filterDetails?.pageSize}
            onChange={(e) => {
              setFilterDetails((draft) => {
                draft.pageSize = e?.target?.value
                draft.pageIndex = 1
              })
            }}
          >
            <option value='10'>10</option>
            <option value='25'>25</option>
            <option value='50'>50</option>
            <option value='100'>100</option>
            <option value='200'>200</option>
            <option value='500'>500</option>
          </select>
        </div>
        <SearchBox
          placeholderText={'Search'}
          searchclassnamewrapper={'searchbox-wrapper'}
          value={searchText}
          onChange={(e) => {
            setSearchText(e?.target?.value)
          }}
        />
      </div>

      <div className='admin_table'>
        <Table className='align-middle table-list mt-3'>
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>User type</th>
              <th>Receive Notification</th>
              <th>Status</th>
              {checkPageAccess(
                pageAccess,
                allPages?.manageAdmin,
                allCrudNames?.update
              ) && <th className='text-center'>Action</th>}
            </tr>
          </thead>
          <tbody>
            {data?.data?.data?.length > 0 ? (
              data?.data?.data?.map((data) => (
                <tr key={data?.id}>
                  <td>
                    <img
                      style={{ width: '50px' }}
                      className='rounded-2'
                      src={
                        data?.profileImage
                          ? `${process.env.REACT_APP_IMG_URL}${_userProfileImg_}${data?.profileImage}`
                          : 'https://place-hold.it/50?text=50x50&fontsize=14'
                      }
                      alt='...'
                    />
                  </td>
                  <td>{`${data?.firstName} ${data?.lastName}`}</td>
                  <td>{data?.userName}</td>
                  <td>{data?.mobileNo}</td>
                  <td>{data?.userType}</td>
                  <td>{data?.receiveNotifications}</td>
                  <td>
                    <HKBadge
                      badgesbgname={
                        data?.status?.toLowerCase() === 'active'
                          ? 'success'
                          : 'danger'
                      }
                      badgesTxtname={data?.status}
                      badgeClassname={''}
                    />
                  </td>
                  {checkPageAccess(
                    pageAccess,
                    allPages?.manageAdmin,
                    allCrudNames?.update
                  ) && (
                    <td className='text-center'>
                      <div className='d-flex gap-2 justify-content-center'>
                        {checkPageAccess(
                          pageAccess,
                          allPages?.manageAdmin,
                          allCrudNames?.update
                        ) && (
                          <span
                            onClick={() => {
                              setInitialValues({
                                ...data,
                                receiveNotifications: data?.receiveNotifications
                                  ?.split(',')
                                  ?.map((data) => {
                                    return { label: data, value: data }
                                  })
                              })
                              setModalShow(!modalShow)
                            }}
                          >
                            <EditIcon bg={'bg'} />
                          </span>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className='text-center'>
                  {data?.data?.message}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {data?.data?.pagination?.pageCount > 0 && (
          <ReactPaginate
            className='list-inline m-cst--pagination d-flex justify-content-end gap-1'
            breakLabel='...'
            nextLabel=''
            onPageChange={handlePageClick}
            pageRangeDisplayed={pageRangeDisplayed}
            pageCount={data?.data?.pagination?.pageCount}
            previousLabel=''
            renderOnZeroPageCount={null}
            forcePage={filterDetails?.pageIndex - 1}
          />
        )}
      </div>

      <Suspense fallback={<Loader />}>
        <AdminForm
          modalShow={modalShow}
          setModalShow={setModalShow}
          loading={loading}
          setLoading={setLoading}
          initialValues={initialValues}
          fetchData={fetchData}
          toast={toast}
          setToast={setToast}
          dropDownData={dropDownData}
        />
      </Suspense>

      {toast?.show && !modalShow && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {loading && !modalShow && <Loader />}
    </>
  )
}

export default AdminList
